import React from 'react';
import { withPageReadyAsync } from '@bingads-webui-react/with-page-ready';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { Placeholder } from './placeholder';

export const getNotificationsBar = (store, config = {}) => withPageReadyAsync(
  () => import(/* webpackMode: 'eager' */'@bingads-webui-campaign/notification-center')
    .then(({ getUnifiedNotificationQueue }) => ({
      default: getUnifiedNotificationQueue(store, config),
    })),
  withI18nConsumer(({ i18n }) => (
    <Placeholder i18n={i18n} />
  ))
);
